import store from '@/store'

export const getGridOperatorByMunicipalityCode = ({ code }) => {
  const option = store.getters['tenant/getMunicipalityOptions'].find(o => o.value === code)
  return option?.gridOperator?.value || ''
}

export function getGridOperators () {
  const municipalityOptions = store.getters['tenant/getMunicipalityOptions']
  const operatorByValue = new Map()
  municipalityOptions.forEach(option => {
    if (option.gridOperator) operatorByValue.set(option.gridOperator.value, option.gridOperator.label)
  })

  return Array.from(operatorByValue, ([value, text]) => ({ text, value }))
}
